<template>
  <v-card>
    <v-tabs dense vertical>
      <v-navigation-drawer permanent :mini-variant="true">
        <v-tab class="tabs">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="pr-4" v-bind="attrs" v-on="on">
                mdi-checkbox-multiple-outline
              </v-icon>
            </template>
            <span>CICLO PRODUZIONE</span>
          </v-tooltip>
        </v-tab>
        <v-tab class="tabs">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="pr-4" v-bind="attrs" v-on="on"> mdi-text </v-icon>
            </template>
            <span>DISTINTA BASE</span>
          </v-tooltip>
        </v-tab>

        <!-- <v-tab class="tabs">
          <v-icon class="pr-4">mdi-handshake-outline</v-icon> IMPEGNO
        </v-tab> -->
        <v-tab class="tabs">
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="pr-4" v-bind="attrs" v-on="on">
                mdi-notebook-edit-outline
              </v-icon>
            </template>
            <span>ANNOTAZIONI</span>
          </v-tooltip>
        </v-tab>
        <v-tab
          v-show="
            $route.params.id != null &&
            $route.params.id > -1 &&
            $route.params.id !== '' &&
            commessa_extra_available == 1
          "
          class="tabs"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="pr-4" v-bind="attrs" v-on="on">
                mdi-file-cog-outline
              </v-icon>
            </template>
            <span>COMMESSA EXTRA</span>
          </v-tooltip>
        </v-tab>
        <v-tab
          v-show="
            $route.params.id != null &&
            $route.params.id > -1 &&
            $route.params.id !== '' &&
            commessa_elementi_available == 1
          "
          class="tabs"
        >
          <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
              <v-icon class="pr-4" v-bind="attrs" v-on="on">
                mdi-vector-difference-ab
              </v-icon>
            </template>
            <span>COMMESSA ELEMENTI</span>
          </v-tooltip>
        </v-tab>
      </v-navigation-drawer>

      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <Cicolo
              @delFornitura="delFornitura($event)"
              @delPersonale="delPersonale($event)"
              @delMacchina="delMacchina($event)"
              @deletedCiclo="deletedCicli($event)"
              @deleteAllFasi="deleteAllFasi($event)"
              :IdArticolo="this.idArticolo"
              :cicloData="this.CicloData"
              :is_quantita_updated="is_quantita_updated"
              ref="ciclo"
              @reload_commessa="handleReloadCommessa"
              @setqueryevent="handleSetQueryEvent"
              :items_tipi_pianificazione="items_tipi_pianificazione"
            />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <!-- Distinta Base originale della commessa -->
      <v-tab-item
        :transition="false"
        :reverse-transition="false"
        style="overflow-y: scroll"
      >
        <Distinta
          v-on:update="updateDrawer($event)"
          :IdArticolo="this.idArticolo"
          :key="key_distinta"
          :CompleteData="this.CicloData"
          @delDistinta="delDistinta($event)"
          @selezionata_distinta="handleSelezionataDistinta"
        />
      </v-tab-item>

      <!-- <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <Impegno :CompleteData="this.completeData" />
          </v-card-text>
        </v-card>
      </v-tab-item> -->
      <v-tab-item :transition="false" :reverse-transition="false">
        <v-card flat>
          <v-card-text class="px-0 py-0">
            <Annotazioni
              :annotazioni_src="
                CicloData.commessa && CicloData.commessa[0]
                  ? CicloData.commessa[0].note
                  : ''
              "
              ref="annotazioni"
            />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        v-show="
          $route.params.id != null &&
          $route.params.id > -1 &&
          $route.params.id !== '' &&
          commessa_extra_available == 1
        "
        :transition="false"
        :reverse-transition="false"
      >
        <v-card flat>
          <v-card-text class="pb-0 pt-5 px-5">
            <CommessaExtra />
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item
        v-show="
          $route.params.id != null &&
          $route.params.id > -1 &&
          $route.params.id !== '' &&
          commessa_elementi_available == 1
        "
        :transition="false"
        :reverse-transition="false"
      >
        <v-card flat>
          <v-card-text class="pb-0 pt-5 px-5">
            <CommessaElementi />
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import Cicolo from "./CommessaCicloProdNew";
import Distinta from "./CommesaDistinta";
// import Impegno from "./CommesaImpegno";
import Annotazioni from "./CommesaAnnotazioni";
import CommessaElementi from "./CommessaElementi";
import CommessaExtra from "./CommessaExtra";

export default {
  props: ["idArticolo", "CicloData", "completeData", "is_quantita_updated", "items_tipi_pianificazione"],
  components: {
    Cicolo,
    Distinta,
    // Impegno,
    Annotazioni,
    CommessaElementi,
    CommessaExtra,
  },
  data() {
    return {
      commessa_elementi_available: 0,
      commessa_extra_available: 0,
      key_distinta: 0,
    };
  },
  methods: {
    delDistinta(event) {
      this.$emit("delDistinta", event);
    },
    handleReloadCommessa(){
      this.$emit("reload_commessa");
    },
    updateDrawer(val) {
      this.$emit("updateDrawer", val);
    },
    deletedCicli(event) {
      this.$emit("DelCiclo", event);
    },
    delMacchina(event) {
      this.$emit("delMacchina", event);
    },
    delPersonale(event) {
      this.$emit("delPersonale", event);
    },
    delFornitura(event) {
      this.$emit("delFornitura", event);
    },
    deleteAllFasi(event) {
      this.$emit("deleteAllFasi", event);
    },
    getModuliDrawer() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getmodulialternativi",
          token: localStorage.user_token,
          codice: "COMMESSA",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            if (!res.data.result) {
              return;
            }

            // Se l'array di risposta è vuoto non faccio nulla
            if (!res.data.result.length > 0) {
              return;
            }

            // Se l'array contiene informazioni sulla commessa extra, le registro.
            if (
              res.data.result.filter((e) => e.descrizione === "COMMESSA_EXTRA")
                .length > 0
            ) {
              this.commessa_extra_available = res.data.result.filter(
                (e) => e.descrizione === "COMMESSA_EXTRA"
              )[0].val_int;
            }

            if (
              res.data.result.filter(
                (e) => e.descrizione === "COMMESSA_ELEMENTI"
              ).length > 0
            ) {
              this.commessa_elementi_available = res.data.result.filter(
                (e) => e.descrizione === "COMMESSA_ELEMENTI"
              )[0].val_int;
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore nella comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch(() => {
          this.$refs.SnackbarQV.print(
            "error",
            "Errore nella comunicazione col server, non è stato possibile caricare i dati."
          );
        });
    },
    handleSelezionataDistinta(arg) {
      this.$emit("selezionata_distinta", arg);
    },
    handleSetQueryEvent() {
      this.$emit("setqueryevent");
    },
  },
  mounted() {
    this.getModuliDrawer();
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  justify-content: start !important;
}
</style>
